<template>
  <div class="blog">
    <div class="blog__title">
      {{ $t('articles') }}
    </div>
    <VBtn
      class="blog__button"
      color="#1FC57F"
      link
      :to="{ name: 'article-create' }"
    >
      {{ $t('createArticle') }}
    </VBtn>
    <div class="blog__header row">
      <div class="col-3 col-sm-2">
        <span class="blog__header-title">{{ $t('date') }}</span>
      </div>
      <div class="col-6 col-sm-8">
        <span class="blog__header-title">{{ $t('title') }}</span>
      </div>
      <div class="col-3 col-sm-2 col-right">
        &nbsp;
      </div>
    </div>
    <BlogArticles />
  </div>
</template>

<script>
import BlogArticles from '@/components/Company/BlogArticles';

export default {
  name: 'Blog',
  components: { BlogArticles },
  props: {
    account: {
      required: true,
      type: Object,
    },
  },
  setup() {
    return {
    };
  },
};
</script>

<style scoped lang="scss">
.blog {
  margin-bottom: 60px;

  &__title {
    font-size: 23px;
    line-height: 20px;
    margin-bottom: 20px;
  }

  &__button {
    height: 30px !important;
    font-size: 12px;
    padding: 0 12px;
  }

  &__header {
    margin-top: 5px;
    border-bottom: 1px solid rgba(#212121, 0.1);

    &-title {
      font-size: 18px;
      color: #757575;
      font-weight: 300;
    }
  }
}
</style>

<i18n lang="yml" locale="en">
articles: Articles
date: Date
blog: Blog
title: Title
createArticle: Create article
</i18n>

<i18n lang="yml" locale="ru">
articles: Статьи
date: Дата
blog: Блог
title: Заголовок
createArticle: Добавить статью
</i18n>
